import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// images
import imageDesktopWebp from './images/promote-financial-education-desktop.webp';
import imageMobileWebp from './images/promote-financial-education-mobile.webp';

export default () => (
  <InformationalModule
    // configs
    sectionId='sustainability-impact-financial-access-financial-education-section'
    themeType='lightTheme'
    backgroundVariant='lightB'
    moduleName='financial-planning-module'
    moduleVariation='A'
    reverseContent
    // content
    subHeadingText='Reducing the wealth gap'
    // column content
    columnContentA={(
      <>
        <Typography nextElement='typography'>
          We exist to free Americans from financial anxiety&#8212;including the people and communities who have been underinsured and left out of financial spaces and conversations.
        </Typography>
        <Typography nextElement='typography'>
          Through Northwestern Mutual&#39;s accelerator program, we aim to reduce barriers to financial access by supporting start&#45;up entrepreneurs from a wide range of constituencies. Each year, Northwestern Mutual selects 10 companies to receive mentorship, access to a 12&#45;week business training program, and a &#36;100,000 investment.{' '}
          <Link
            id='who-we-are-working-financial-a-advisor'
            variant='primaryDeemphasize'
            isOutgoingLink
            linkUrl='https://www.gener8tor.com/investment-accelerators/northwestern-mutual-black-founder-accelerator/'>
            Find out more
          </Link>.
        </Typography>
        <Typography nextElement='typography'>
          By partnering with qualified suppliers, regardless of their size or ownership, we&#39;re helping entrepreneurs strengthen the communities they operate in and drive economic growth, while contributing to a value&#45;centered and resilient supply chain.{' '}
          <Link
            id='who-we-are-financial-diversity'
            variant='primaryDeemphasize'
            linkUrl='/supplier-diversity/'>
            Partner with us
          </Link>.
        </Typography>
      </>
    )}
    // image props
    imageAltText='People attending a conference engaged and attentive.'
    imageSrcDefault={imageDesktopWebp}
    imageSrcMobile={imageMobileWebp}
  />
);
